import React from "react"
import { NavLink } from "react-router-dom"
import { HiClipboardList } from "react-icons/hi"
import { FaCar, FaCarBattery, FaUserTag } from "react-icons/fa"
import { MdInventory } from "react-icons/md"
import { BsFileEarmarkRichtextFill } from "react-icons/bs"
import { AiOutlineFieldTime, AiFillShopping, AiFillTool } from "react-icons/ai"
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService"
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded"
import Vista from "../../components/Vista"
import FullScreenLoader from "../../components/FullScreenLoader"
import { useAuth } from "../../hooks/useAuth"
import { useLocalStorage } from "../../hooks/useLocalStorage"
import "../zonda-redesign.css"
import { canViewModule } from "../../utils/moduleAccess"

const modules = [
  { permission: "checklists", to: "/checklists", label: "Checklist", description: "Inspección de unidades", icon: HiClipboardList },
  { permission: "checklistsEmpleados", to: "/checklistsEmpleados", label: "Checklists préstamos", description: "Control de resguardos", icon: HiClipboardList },
  { permission: "carros", to: "/carros", label: "Carros", description: "Gestión de flotilla", icon: FaCar },
  { permission: "productos", to: "/productos", label: "Productos", description: "Catálogo de refacciones", icon: FaCarBattery },
  { permission: "inventarios", to: "/inventarios", label: "Inventarios", description: "Existencias y movimientos", icon: MdInventory },
  { permission: "manosObra", to: "/manosObra", label: "Manos de obra", description: "Servicios y tiempos", icon: AiOutlineFieldTime },
  { permission: "proveedores", to: "/proveedores", label: "Proveedores", description: "Directorio comercial", icon: FaUserTag },
  { permission: "ordenServicios", to: "/ordenServicios", label: "Orden de servicio", description: "Seguimiento de taller", icon: BsFileEarmarkRichtextFill, featured: true },
  { permission: "compras", to: "/compras", label: "Compras", description: "Órdenes y adquisiciones", icon: AiFillShopping },
  { permission: "proximoServicio", to: "/proximoServicio", label: "Próximo servicio", description: "Agenda de mantenimiento", icon: AiFillTool },
  { permission: "herramientas", to: "/herramientas", label: "Herramientas", description: "Inventario de taller", icon: HomeRepairServiceIcon }
]

const Home = () => {
  const { loginLoading } = useAuth()
  const [permiso] = useLocalStorage("permiso", {})

  if (loginLoading || !permiso || Object.keys(permiso).length === 0) return <FullScreenLoader />
  const enabledCount = modules.filter(({ permission }) => canViewModule(permiso, permission)).length

  return (
    <Vista style={{ display: "block" }}>
      <main className="zonda-home">
        <section className="zonda-hero">
          <img className="zonda-hero__image" src="https://firebasestorage.googleapis.com/v0/b/zonda-b0ce9.appspot.com/o/Sistema%2Fimagen_web_zonda.png?alt=media&token=7d54e2ae-ec5f-4d2d-b2ad-da876a4b8d99&_gl=1*84gx10*_ga=MTA2MTM0NDcyMC4xNjc3MTAxNzk3*_ga_CW55HF8NVT*MTY4NjU5MzU3Mi4xOC4xLjE2ODY1OTM2MjUuMC4wLjA." alt="Flotilla Zonda" />
          <div className="zonda-hero__overlay" />
          <div className="zonda-hero__content">
            <img className="zonda-hero__logo" src="https://firebasestorage.googleapis.com/v0/b/zonda-b0ce9.appspot.com/o/Sistema%2FLogotipo-Zonda-Vector.svg?alt=media&token=e3d435da-9937-473b-8994-f4ac1cd7b850&_gl=1*da6o61*_ga=MTA2MTM0NDcyMC4xNjc3MTAxNzk3*_ga_CW55HF8NVT*MTY4NjU5MzU3Mi4xOC4xLjE2ODY1OTM2NDkuMC4wLjA." alt="Zonda" />
            <p className="zonda-hero__eyebrow">Centro de operaciones</p>
            <h1>Todo tu taller, en un solo lugar</h1>
            <p className="zonda-hero__copy">Consulta, administra y da seguimiento a las operaciones de tu flotilla.</p>
          </div>
        </section>

        <section className="zonda-module-panel" aria-labelledby="module-title">
          <div className="zonda-section-heading">
            <div>
              <span className="zonda-section-heading__tag">Panel principal</span>
              <h2 id="module-title">¿Qué deseas gestionar?</h2>
              <p>Selecciona un módulo para comenzar.</p>
            </div>
            <span className="zonda-access-count">{enabledCount} módulos disponibles</span>
          </div>
          <div className="zonda-module-grid">
            {modules.map(({ permission, to, label, description, icon: Icon, featured }) => {
              const enabled = canViewModule(permiso, permission)
              const card = <><span className="zonda-module-card__icon"><Icon /></span><span className="zonda-module-card__body"><strong>{label}</strong><small>{enabled ? description : "Sin acceso asignado"}</small></span><ArrowForwardRoundedIcon className="zonda-module-card__arrow" /></>
              return enabled ? <NavLink key={permission} to={to} className={`zonda-module-card${featured ? " zonda-module-card--featured" : ""}`}>{card}</NavLink> : <div key={permission} className="zonda-module-card zonda-module-card--disabled" aria-disabled="true">{card}</div>
            })}
          </div>
        </section>
      </main>
    </Vista>
  )
}

export default Home
